module.exports = __webpack_public_path__ + "img/ki.2fa0e53d.svg";